import React from "react";

const CronStatusBadge = ({ status, isRunning }) => {
  if (isRunning) {
    return (
      <span className="px-3 py-1 text-xs font-medium bg-yellow-100 text-yellow-700 rounded-full">
        Running...
      </span>
    );
  }

  if (!status) {
    return (
      <span className="px-3 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
        Never Run
      </span>
    );
  }

  const styles = {
    SUCCESS: "bg-green-100 text-green-700",
    FAILED: "bg-red-100 text-red-700",
    SKIPPED: "bg-gray-200 text-gray-700",
  };

  return (
    <span
      className={`px-3 py-1 text-xs font-medium rounded-full ${
        styles[status] || "bg-gray-100 text-gray-600"
      }`}
    >
      {status}
    </span>
  );
};

export default CronStatusBadge;